



/*slider home*/
if(document.querySelector('#shopify-section-template--18729853911338__16361066840a222f4b')) {
  let cont = document.querySelector('#shopify-section-template--18729853911338__16361066840a222f4b');
  let indicator0 = document.createElement('div');
  let indicator1 = document.createElement('div');

  indicator0.id = 'block-16361066840a222f4b-0-indicator';
  indicator0.classList.add('active');
  indicator1.id = 'block-16361066840a222f4b-1-indicator';
  
  cont.appendChild(indicator0);
  cont.appendChild(indicator1);

  let carr = document.querySelector('#section-template--18729853911338__16361066840a222f4b');
  carr.addEventListener('scroll', (ev) => {
    if(carr.scrollTop == 0) {
      indicator0.classList.add('active');
      indicator1.classList.remove('active');
    } else {
      indicator0.classList.remove('active');
      indicator1.classList.add('active');
    }
      
  });
}


/*submenu categories*/
if(document.querySelector('#collection-menu .site-nav-container .link-list')) {
  let menu = document.querySelector('#collection-menu .site-nav-container .link-list');
  let arrlft = document.querySelector('#collection-menu .menu-arrow-nav.menu-arrow-nav-left');
  let arrght = document.querySelector('#collection-menu .menu-arrow-nav.menu-arrow-nav-right');

  arrlft.addEventListener('click', (ev) => {
    menu.scroll({top: 0, left: menu.scrollLeft -81, behavior: "smooth"});
  });
  arrght.addEventListener('click', (ev) => {
    menu.scroll({top: 0, left: menu.scrollLeft +81, behavior: "smooth"});
  });
}


/* reletaed products */
let inter = setInterval(() => {
  if(document.querySelector('.product-recommendations .product-grid-border-fix')) {
    let list = document.querySelector('.product-recommendations .product-grid-border-fix');
    let arrlft = document.querySelector('.related-products-navigation .previus');
    let arrght = document.querySelector('.related-products-navigation .next');

    arrlft.addEventListener('click', (ev) => {
      list.scroll({top: 0, left: list.scrollLeft -(window.innerWidth *.2), behavior: "smooth"});
    });
    arrght.addEventListener('click', (ev) => {
      list.scroll({top: 0, left: list.scrollLeft +(window.innerWidth *.2), behavior: "smooth"});
    });
    
    clearInterval(inter);
  }
}, 1000);


/* product */
if(document.querySelector('.swipe-product-bar') && document.querySelector('.css-slider-container-mm')) {
  let bar = document.querySelector('.swipe-product-bar');
  let slider = document.querySelector('.css-slider-container-mm');

  window.scrollTo(0, 0);
  window.onbeforeunload = () => {window.scrollTo(0, 0);}
  document.body.classList.add('disable-scroll');

  bar.addEventListener('click', (ev) => {
    if(false) {
      bar.classList.toggle('opened');
      slider.classList.toggle('folded');
  
      window.scrollTo(0, 0);
      document.body.classList.toggle('disable-scroll');
    }
  });

  let hgt = 50;
  let moveHandler = (e) => {
    e.preventDefault();
    
    const dy = e.clientY || e.touches[0].clientY;
    const headerHeight = document.querySelector('#shopify-section-sections--18729851257130__header').clientHeight + document.querySelector('#shopify-section-sections--18729851257130__announcement').clientHeight;
    const pos = (dy - headerHeight) / window.innerHeight * 100;
    hgt = Math.min(Math.max(pos, 0), 50);

    slider.classList.add('dragged');
    slider.style.height = hgt +'vh';
  }
  let upHandler = (e) => {
    e.preventDefault();
    
    if(slider.classList.contains('dragged')) {
      slider.classList.remove('dragged');
      slider.style.height = '';
      
      if(!slider.classList.contains('folded') && hgt < 40) {
        slider.classList.add('folded');
        bar.classList.add('opened');
        document.body.classList.remove('disable-scroll');
      } else if(slider.classList.contains('folded') && hgt > 10) {
        slider.classList.remove('folded');
        bar.classList.remove('opened');
        document.body.classList.add('disable-scroll');
      }
    } else {
      bar.classList.toggle('opened');
      slider.classList.toggle('folded');
  
      window.scrollTo(0, 0);
      document.body.classList.toggle('disable-scroll');
    }

    document.removeEventListener('mousemove', moveHandler);
    document.removeEventListener('mouseup', upHandler);
    document.removeEventListener('touchmove', moveHandler);
    document.removeEventListener('touchend', upHandler);
  }
  bar.addEventListener('mousedown', (ev) => {
    document.addEventListener('mousemove', moveHandler);
    document.addEventListener('mouseup', upHandler);
    document.addEventListener('touchmove', moveHandler);
    document.addEventListener('touchend', upHandler);
  });
  bar.addEventListener('touchstart', (ev) => {
    document.addEventListener('mousemove', moveHandler);
    document.addEventListener('mouseup', upHandler);
    document.addEventListener('touchmove', moveHandler);
    document.addEventListener('touchend', upHandler);
  });
}


/* menu overlay */
document.getElementById('site-menu-handle').addEventListener('click', (ev) => {
  document.body.classList.add('hide-overlay');
});
document.getElementById('site-menu-handle-close').addEventListener('click', (ev) => {
  document.body.classList.remove('hide-overlay');
  document.querySelector('#site-overlay').click();
});
document.querySelector('.cart-menu').addEventListener('click', (ev) => {
  if(document.body.classList.contains('hide-overlay')) {
    document.body.classList.remove('hide-overlay');
    document.querySelector('#site-overlay').click();
  }
});

